; (function(global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/Teams/Navigation/TeamFooterButtonGroup',["jquery"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery")) :
        console && console.error('TeamFooterButtonGroup does not support non-amd script loading.');
}(this/* window */, function($) {
    function TeamFooterButtonGroup(scope, isHidden) {
        Object.defineProperties(this, {
            scope: { writable: !1, configurable: !0, enumerable: !0, value: scope },
            isHidden: { writable: !1, configurable: !0, enumerable: !0, value: isHidden }
        });

        if (this.isHidden) {
            this.scope.style.display = 'none';
        }
    }

    return function init(args) {
        return args.IsExperienceEditorEditing ? null : new TeamFooterButtonGroup(args.scope, args.IsHidden);
    };
}));
